import { Package, PackageHost } from '../../Container';
import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { inLensCommands } from './LensCommands';
import { LensInfo } from './LensInfo';
import { LensMechanics } from './LensMechanics';
import { LensReflector } from './LensReflector';
import { LensWidgetMechanics } from './LensWidget';
import { MqlUtils } from './MqlUtils';

export class LensPackage implements Package {

    public install = (host: PackageHost) => host
        .register(MqlUtils, 'singleton')
        .register(LensMechanics, 'singleton', 'startable')
        .register(LensReflector, 'singleton')
        .register(LensWidgetMechanics, 'singleton', 'startable')
        .plug(inSessionProperties(
            StateProperty.variable(LensInfo, LensInfo.empty),
        ))
        .plug(inLensCommands())
        ;
}

